<template>
    <v-container v-if="isLoaded">
        <div v-if="menus.length > 0">
            <v-row>
                <v-col cols="12">
                    <v-card>
                        <v-toolbar flat color="white">
                            <!-- <v-btn color="primary" text @click="$router.push({ name: 'businesses' })"><v-icon>keyboard_arrow_left</v-icon>Businesses </v-btn> -->
                            <v-toolbar-title>Menus</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" @click="openEditMenuDialog()"> <v-icon>add</v-icon>Create </v-btn>
                        </v-toolbar>
                    </v-card>
                </v-col>
            </v-row>
            <v-row>
                <v-col v-if="viewMode" cols="12">
                    <v-data-table :headers="headers" :items="menus" :items-per-page="100" class="elevation-1">
                        <template v-slot:item="props">
                            <tr
                                @click="
                                    $router.push({
                                        name: 'menu-categories',
                                        params: { menuId: props.item.id },
                                    })
                                "
                            >
                                <td class="text-xs-left">
                                    {{ props.item.order }}
                                </td>
                                <td class="text-xs-left">
                                    {{ props.item | displayLang('title', $store.state.lang) }}
                                </td>
                                <td class="text-xs-left">
                                    {{ props.item | displayLang('description', $store.state.lang) }}
                                </td>
                                <td class="text-xs-left">
                                    {{ props.item.number_of_categories }}
                                </td>
                                <td class="text-xs-left">
                                    {{ props.item.visibility }}
                                </td>
                                <td class="text-xs-left">
                                    <v-icon small class="mr-2" @click.stop="openEditMenuDialog(props.item)">edit</v-icon>
                                    <v-icon small @click.stop="openDeleteMenuDialog(props.item)">delete</v-icon>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </div>
        <v-parallax v-else dark style="background-color: #C3C3C3;">
            <v-row align="center" justify="center">
                <v-col>
                    <h1 class="display-2 font-weight-thin mb-3">
                        Business menu configuration
                    </h1>
                    <h4 class="subheading">
                        Business has not configiured menu...
                    </h4>
                    <v-btn color="primary" @click="openEditMenuDialog()">Create </v-btn>
                </v-col>
            </v-row>
        </v-parallax>
        <v-dialog v-model="editMenuDialog" width="500" persistent>
            <v-card>
                <v-toolbar flat color="white">
                    <v-toolbar-title v-if="menu.id">Edit menu</v-toolbar-title>
                    <v-toolbar-title v-else>New menu</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-title>
                        <v-btn v-for="langObject in langs" :key="langObject.value" small icon @click="pickLang(langObject)" :class="{ selected: lang === langObject.value }"
                            ><flag :iso="langObject.icon"
                        /></v-btn>
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-form v-on:submit.prevent ref="menuForm" v-model="valid" lazy-validation @keydown.native="dialogKeyEventHandler">
                        <v-row dense>
                            <v-col cols="12" v-if="lang === 'english'">
                                <v-text-field
                                    v-model="menu.title_en"
                                    ref="title_en"
                                    :label="titleLabel"
                                    prepend-icon="label"
                                    :rules="[rules.required]"
                                    dense
                                    @change="updateTitle()"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" v-if="lang === 'english'">
                                <v-textarea
                                    v-model="menu.description_en"
                                    :label="descriptionLabel"
                                    prepend-icon="description"
                                    dense
                                    rows="2"
                                    @change="updateDescription()"
                                ></v-textarea>
                            </v-col>
                            <v-col cols="12" v-if="lang === 'greek'">
                                <v-text-field v-model="menu.title_gr" ref="title_gr" :label="titleLabel" prepend-icon="label" dense></v-text-field>
                            </v-col>
                            <v-col cols="12" v-if="lang === 'greek'">
                                <v-textarea v-model="menu.description_gr" :label="descriptionLabel" prepend-icon="description" dense rows="2"></v-textarea>
                            </v-col>
                            <v-col v-if="menu.id" cols="6">
                                <v-text-field v-model="menu.order" type="number" label="Order" prepend-icon="cake" dense></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-switch class="ml-0 px-0 mt-1" v-model="menu.visibility" label="Visible"></v-switch>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="gray" text @click="editMenuDialog = false">Cancel</v-btn>
                    <v-btn color="error" text @click="validate()">
                        <span v-if="menu.id">Update</span>
                        <span v-else>Create</span>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="deleteMenuDialog" width="400">
            <v-card>
                <v-toolbar flat color="white">
                    <v-toolbar-title>Delete menu {{ menu.title_en }}</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    Are you sure you want to delete menu {{ menu.title_en }}?
                    <span v-if="menu.number_of_categories && menu.number_of_categories.length > 0">
                        There are {{ menu.number_of_categories }} categories in this menu which will be lost!!
                    </span>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="gray" text @click="deleteMenuDialog = false">Cancel</v-btn>
                    <v-btn color="error" text @click="deleteMenu()">Delete</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import * as R from 'ramda';
import { BusinessesApi, MenuApi } from '@/api';
import { dates, fonts, filters } from '@/utils/mixins';
import { SET_SNACKBAR_STATUS } from '@/store/mutation-types';

export default {
    name: 'Menu',
    mixins: [dates, fonts, filters],
    data() {
        return {
            isLoaded: false,
            menus: [],
            titleLabel: 'Title - EN',
            descriptionLabel: 'Description - EN',
            viewMode: true,
            valid: true,
            menu: {},
            editMenuDialog: false,
            deleteMenuDialog: false,
            lang: 'english',
            langs: [
                {
                    text: 'English',
                    value: 'english',
                    icon: 'gb',
                },
                {
                    text: 'Greek',
                    value: 'greek',
                    icon: 'gr',
                },
            ],
            headers: [
                {
                    text: 'Order',
                    value: 'order',
                    align: 'left',
                    width: '5%',
                    sortable: true,
                },
                {
                    text: 'Title',
                    value: 'title_en',
                    align: 'left',
                    width: '20%',
                    sortable: true,
                },
                {
                    text: 'Description',
                    value: 'description_en',
                    align: 'left',
                    width: '20%',
                    sortable: false,
                },
                {
                    text: 'Categories',
                    value: 'number_of_categories',
                    align: 'left',
                    width: '5%',
                    sortable: true,
                },
                {
                    text: 'Visible',
                    value: 'visibility',
                    align: 'left',
                    width: '5%',
                    sortable: true,
                },
                {
                    align: '',
                    sortable: false,
                    text: 'Actions',
                    value: 'action',
                    width: '5%',
                },
            ],
            rules: {
                required: value => !!value || 'Field is required',
            },
        };
    },
    async created() {
        await this.loadMenus();
        this.isLoaded = true;
    },
    methods: {
        dialogKeyEventHandler(event) {
            if (event.key === 'Escape') {
                this.editMenuDialog = false;
            }

            if (event.ctrlKey && event.key === '1') {
                event.preventDefault();
                this.pickLang(this.langs[0]);
            }
            if (event.ctrlKey && event.key === '2') {
                event.preventDefault();
                this.pickLang(this.langs[1]);
            }
            if (event.shiftKey && event.key === 'Enter') {
                this.validate();
                this.openEditMenuDialog();
            } else if (event.key === 'Enter') {
                this.validate();
            }
        },
        updateTitle() {
            if (this.menu.title_gr === null || this.menu.title_gr === undefined) {
                this.menu.title_gr = this.menu.title_en;
            }
        },
        updateDescription() {
            if (this.menu.description_gr === null || this.menu.description_gr === undefined) {
                this.menu.description_gr = this.menu.description_en;
            }
        },
        pickLang(selectedLang) {
            this.lang = selectedLang.value;
            this.$nextTick(() => {
                if (this.lang === 'english') {
                    this.$refs.title_en.focus();
                    this.titleLabel = 'Title - EN';
                    this.descriptionLabel = 'Description - EN';
                }
                if (this.lang === 'greek') {
                    this.$refs.title_gr.focus();
                    this.titleLabel = 'Title - GR';
                    this.descriptionLabel = 'Description - GR';
                }
            });
        },
        validate() {
            if (this.$refs.menuForm.validate()) {
                this.updateMenu();
            }
        },
        reset() {
            if (this.$refs.menuForm) {
                this.$refs.menuForm.reset();
                this.lang = 'english';
                this.pickLang(this.langs[0]);
            }
        },
        async loadMenus() {
            const { data: business } = await BusinessesApi.get(this.$route.params.id);
            if (business.menus) {
                this.menus = [];
                try {
                    business.menus.forEach(async menuItem => {
                        const { data: menu } = await MenuApi.get(menuItem.id);
                        this.menus.push(menu);
                    });
                } catch (e) {
                    this.menus = [];
                }
            }
        },
        async createMenu() {
            const { data: menu } = await MenuApi.create({
                business: this.$route.params.id,
            });
            this.menu = menu;
            await this.loadMenus();
        },
        openEditMenuDialog(menu) {
            this.lang = 'english';
            if (menu === undefined) {
                this.menu = {};
                this.reset();
                this.menu.visibility = true;
            } else {
                this.menu = R.clone(menu);
            }
            this.editMenuDialog = true;
            this.$nextTick(() => {
                this.$nextTick(() => {
                    this.$refs.title_en.focus();
                });
            });
        },
        async updateMenu() {
            this.menu.business = this.$route.params.id;
            this.editMenuDialog = false;
            if (this.menu.id) {
                await MenuApi.update(this.menu);
            } else {
                await MenuApi.create(this.menu);
            }
            this.loadMenus();
            this.$store.commit(SET_SNACKBAR_STATUS, {
                message: 'Menu created!',
                color: 'success',
            });
            this.menu = {};
        },
        openDeleteMenuDialog(menu) {
            this.menu = menu;
            this.deleteMenuDialog = true;
        },
        async deleteMenu() {
            await MenuApi.delete(this.menu.id);
            this.loadMenus();
            this.$store.commit(SET_SNACKBAR_STATUS, {
                message: `Menu ${this.menu.title_en}`,
                color: 'success',
            });
            this.deleteMenuDialog = false;
            this.menu = {};
        },
    },
};
</script>

<style scoped>
.selected {
    background-color: rgba(100, 200, 300, 0.8);
}
</style>
